<template>
    <div class="table-responsive">
        <table class="table-bordered table">
            <colgroup>
                <col style="width: 200px" />
                <col style="width: auto" />
                <col style="width: 150px" />
                <col style="width: 150px" />
            </colgroup>
            <tbody>
                <tr>
                    <th>■CP概要</th>
                    <th></th>
                    <th>1次チェック</th>
                    <th>2次チェック</th>
                </tr>
                <template v-for="(item, index) in dataObject.overview_campaign">
                    <tr :key="index + 'a'" v-if="SWITCH_FIELD_TAB_5(item, isPreview)['SNS']">
                        <td class="bg-color1">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_5(item)['SNS']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            sns: item.sns
                                        })
                                    "
                                />
                                SNS
                            </div>
                        </td>
                        <td>
                            <TextareaComponent
                                :id="'tab5-textarea-sns-' + index"
                                :model.sync="item.sns.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_5(item)['SNS']"
                                :isPreview="isPreview"
                                :config="inputConfig.sns"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields[`overview_campaign_sns_${index}_first`])"
                                v-model="item.sns.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('overview_campaign', 'first', index, 'sns')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields[`overview_campaign_sns_${index}_secondary`])"
                                v-model="item.sns.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('overview_campaign', 'secondary', index, 'sns')"
                            />
                        </td>
                    </tr>
                    <tr :key="index + 'b'" v-if="SWITCH_FIELD_TAB_5(item, isPreview)['ツール']">
                        <td class="bg-color1">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_5(item)['ツール']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            collection_tools: item.collection_tools
                                        })
                                    "
                                />
                                収集ツール
                            </div>
                        </td>
                        <td>
                            <TextareaComponent
                                :id="'tab5-textarea-tools-' + index"
                                :model.sync="item.collection_tools.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_5(item)['ツール']"
                                :isPreview="isPreview"
                                :config="inputConfig.collection_tools"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="
                                    isNotCheckBoxPartner ||
                                    (processingFields && processingFields[`overview_campaign_collection_tools_${index}_first`])
                                "
                                v-model="item.collection_tools.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('overview_campaign', 'first', index, 'collection_tools')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="
                                    isNotCheckBoxPartner ||
                                    (processingFields && processingFields[`overview_campaign_collection_tools_${index}_secondary`])
                                "
                                v-model="item.collection_tools.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('overview_campaign', 'secondary', index, 'collection_tools')"
                            />
                        </td>
                    </tr>
                    <tr
                        v-if="item.campaign_name_atelu_only.data && SWITCH_FIELD_TAB_5(item, isPreview)['ンペーン名（ATELUのみ）']"
                        :key="index + 'c'"
                    >
                        <td class="bg-color1">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_5(item)['ンペーン名（ATELUのみ）']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            campaign_name_atelu_only: item.campaign_name_atelu_only
                                        })
                                    "
                                />
                                ンペーン名（ATELUのみ）
                            </div>
                        </td>
                        <td>
                            <TextareaComponent
                                :id="'tab5-textarea-atelu-' + index"
                                :model.sync="item.campaign_name_atelu_only.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_5(item)['ンペーン名（ATELUのみ）']"
                                :isPreview="isPreview"
                                :config="inputConfig.campaign_name_atelu_only"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="
                                    isNotCheckBoxPartner ||
                                    (processingFields && processingFields[`overview_campaign_campaign_name_atelu_only_${index}_first`])
                                "
                                v-model="item.campaign_name_atelu_only.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('overview_campaign', 'first', index, 'campaign_name_atelu_only')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="
                                    isNotCheckBoxPartner ||
                                    (processingFields && processingFields[`overview_campaign_campaign_name_atelu_only_${index}_secondary`])
                                "
                                v-model="item.campaign_name_atelu_only.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('overview_campaign', 'secondary', index, 'campaign_name_atelu_only')"
                            />
                        </td>
                    </tr>
                    <tr :key="index + 'd'" v-if="SWITCH_FIELD_TAB_5(item, isPreview)['収集対象タグ']">
                        <td class="bg-color1">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_5(item)['収集対象タグ']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            tag_collected: item.tag_collected
                                        })
                                    "
                                />
                                収集対象タグ
                            </div>
                        </td>
                        <td>
                            <TextareaComponent
                                :id="'tab5-textarea-tag-' + index"
                                :model.sync="item.tag_collected.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_5(item)['収集対象タグ']"
                                :isPreview="isPreview"
                                :config="inputConfig.tag_collected"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="
                                    isNotCheckBoxPartner || (processingFields && processingFields[`overview_campaign_tag_collected_${index}_first`])
                                "
                                v-model="item.tag_collected.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('overview_campaign', 'first', index, 'tag_collected')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="
                                    isNotCheckBoxPartner ||
                                    (processingFields && processingFields[`overview_campaign_tag_collected_${index}_secondary`])
                                "
                                v-model="item.tag_collected.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('overview_campaign', 'secondary', index, 'tag_collected')"
                            />
                        </td>
                    </tr>
                </template>
                <tr v-if="SWITCH_FIELD_TAB_5(dataObject, isPreview)['■CP概要その他先_5']">
                    <td class="bg-color1">
                        <b-form-checkbox
                            v-if="!isPreview && !isRolePartner"
                            class="mb-1"
                            switch
                            v-model="SWITCH_FIELD_TAB_5(dataObject)['■CP概要その他先_5']"
                            @change="toggleCommonSwitch($event, { free_block_campaign_overview: dataObject.free_block_campaign_overview })"
                        />
                        <b-form-input
                            v-model="dataObject.free_block_campaign_overview.title"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_5(dataObject)['■CP概要その他先_5']"
                            :class="`${isDisabled || !SWITCH_FIELD_TAB_5(dataObject)['■CP概要その他先_5'] ? 'disabled_cursor' : ''}`"
                        ></b-form-input>
                    </td>
                    <td>
                        <div
                            v-if="isNotCheckBoxPartner || isDisabled"
                            class="box--text__disabled"
                            v-html="dataObject.free_block_campaign_overview.data"
                        ></div>
                        <Editor
                            v-else
                            :id="`editor-■CP概要その他先_5-${idTab}`"
                            :model.sync="dataObject.free_block_campaign_overview.data"
                            :configInit="{
                                disabled: forceEnableEditors ? false : isDisabled || !SWITCH_FIELD_TAB_5(dataObject)['■CP概要その他先_5'],
                                is_autoresize_on: true
                            }"
                        />
                    </td>
                </tr>

                <tr>
                    <th colspan="4">■応募数報告</th>
                </tr>
                <template v-if="SWITCH_FIELD_TAB_5(dataObject, isPreview)['報告スケジュール']">
                    <tr>
                        <td rowspan="2" class="bg-color1">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_5(dataObject)['報告スケジュール']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            reporting_schedule: dataObject.reporting_schedule,
                                            reporting_schedule_detail: dataObject.reporting_schedule_detail
                                        })
                                    "
                                />
                                報告スケジュール
                            </div>
                        </td>
                        <td>
                            <InputText
                                :model.sync="dataObject.reporting_schedule.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_5(dataObject)['報告スケジュール']"
                                :config="inputConfig.reporting_schedule"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.reporting_schedule_first)"
                                v-model="dataObject.reporting_schedule.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('reporting_schedule', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.reporting_schedule_secondary)"
                                v-model="dataObject.reporting_schedule.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('reporting_schedule', 'secondary')"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <TextareaComponent
                                id="tab5-textarea-1"
                                :model.sync="dataObject.reporting_schedule_detail.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_5(dataObject)['報告スケジュール']"
                                :isPreview="isPreview"
                                :config="inputConfig.reporting_schedule_detail"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.reporting_schedule_detail_first)"
                                v-model="dataObject.reporting_schedule_detail.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('reporting_schedule_detail', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.reporting_schedule_detail_secondary)"
                                v-model="dataObject.reporting_schedule_detail.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('reporting_schedule_detail', 'secondary')"
                            />
                        </td>
                    </tr>
                </template>

                <template v-if="SWITCH_FIELD_TAB_5(dataObject, isPreview)['報告内容']">
                    <tr>
                        <td rowspan="3" class="bg-color1">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_5(dataObject)['報告内容']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            contents_of_report: dataObject.contents_of_report,
                                            contents_of_report_detail: dataObject.contents_of_report_detail,
                                            contents_of_report_twitter_rt: dataObject.contents_of_report_twitter_rt
                                        })
                                    "
                                />
                                報告内容
                            </div>
                        </td>
                        <td
                            :class="{
                                disabled_cursor: isDisabled
                            }"
                        >
                            <CommonMultiselect
                                v-model="dataObject.contents_of_report.data"
                                :options.sync="option.contents_of_report"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_5(dataObject)['報告内容']"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.contents_of_report_first)"
                                v-model="dataObject.contents_of_report.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('contents_of_report', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.contents_of_report_secondary)"
                                v-model="dataObject.contents_of_report.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('contents_of_report', 'secondary')"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <TextareaComponent
                                id="tab5-textarea-2"
                                :model.sync="dataObject.contents_of_report_twitter_rt.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_5(dataObject)['報告内容']"
                                :isPreview="isPreview"
                                :config="inputConfig.contents_of_report_twitter_rt"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.contents_of_report_twitter_rt_first)"
                                v-model="dataObject.contents_of_report_twitter_rt.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('contents_of_report_twitter_rt', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.contents_of_report_twitter_rt_secondary)"
                                v-model="dataObject.contents_of_report_twitter_rt.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('contents_of_report_twitter_rt', 'secondary')"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <TextareaComponent
                                id="tab5-textarea-3"
                                :model.sync="dataObject.contents_of_report_detail.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_5(dataObject)['報告内容']"
                                :isPreview="isPreview"
                                :config="inputConfig.contents_of_report_detail"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.contents_of_report_detail_first)"
                                v-model="dataObject.contents_of_report_detail.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('contents_of_report_detail', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.contents_of_report_detail_secondary)"
                                v-model="dataObject.contents_of_report_detail.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('contents_of_report_detail', 'secondary')"
                            />
                        </td>
                    </tr>
                </template>
                <template v-if="SWITCH_FIELD_TAB_5(dataObject, isPreview)['収集対象投稿(URL)']">
                    <tr>
                        <td rowspan="2" class="bg-color1">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_5(dataObject)['収集対象投稿(URL)']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            post_to_be_collected_word: dataObject.post_to_be_collected_word,
                                            post_to_be_collected_url: dataObject.post_to_be_collected_url
                                        })
                                    "
                                />
                                収集対象投稿(URL)
                            </div>
                        </td>
                        <td>
                            <TextareaComponent
                                id="tab5-textarea-4"
                                :model.sync="dataObject.post_to_be_collected_word.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_5(dataObject)['収集対象投稿(URL)']"
                                :isPreview="isPreview"
                                :config="inputConfig.post_to_be_collected_word"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.post_to_be_collected_word_first)"
                                v-model="dataObject.post_to_be_collected_word.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('post_to_be_collected_word', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.post_to_be_collected_word_secondary)"
                                v-model="dataObject.post_to_be_collected_word.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('post_to_be_collected_word', 'secondary')"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <TextareaComponent
                                id="tab5-textarea-5"
                                :model.sync="dataObject.post_to_be_collected_url.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_5(dataObject)['収集対象投稿(URL)']"
                                :isPreview="isPreview"
                                :config="inputConfig.post_to_be_collected_url"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.post_to_be_collected_url_first)"
                                v-model="dataObject.post_to_be_collected_url.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('post_to_be_collected_url', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.post_to_be_collected_url_secondary)"
                                v-model="dataObject.post_to_be_collected_url.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('post_to_be_collected_url', 'secondary')"
                            />
                        </td>
                    </tr>
                </template>

                <template v-if="SWITCH_FIELD_TAB_5(dataObject, isPreview)['テスト応募']">
                    <tr>
                        <td rowspan="3" class="bg-color1">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_5(dataObject)['テスト応募']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            test_application_1: dataObject.test_application_1,
                                            test_application_2: dataObject.test_application_2,
                                            test_application_3: dataObject.test_application_3
                                        })
                                    "
                                />
                                テスト応募
                            </div>
                        </td>
                        <td>
                            <TextareaComponent
                                id="tab5-textarea-6"
                                :model.sync="dataObject.test_application_1.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_5(dataObject)['テスト応募']"
                                :isPreview="isPreview"
                                :config="inputConfig.test_application_1"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.test_application_1_first)"
                                v-model="dataObject.test_application_1.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('test_application_1', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.test_application_1_secondary)"
                                v-model="dataObject.test_application_1.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('test_application_1', 'secondary')"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <TextareaComponent
                                id="tab5-textarea-7"
                                :model.sync="dataObject.test_application_2.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_5(dataObject)['テスト応募']"
                                :isPreview="isPreview"
                                :config="inputConfig.test_application_2"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.test_application_2_first)"
                                v-model="dataObject.test_application_2.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('test_application_2', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.test_application_2_secondary)"
                                v-model="dataObject.test_application_2.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('test_application_2', 'secondary')"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <TextareaComponent
                                id="tab5-textarea-8"
                                :model.sync="dataObject.test_application_3.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_5(dataObject)['テスト応募']"
                                :isPreview="isPreview"
                                :config="inputConfig.test_application_3"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.test_application_3_first)"
                                v-model="dataObject.test_application_3.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('test_application_3', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.test_application_3_secondary)"
                                v-model="dataObject.test_application_3.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('test_application_3', 'secondary')"
                            />
                        </td>
                    </tr>
                </template>
                <tr v-if="SWITCH_FIELD_TAB_5(dataObject, isPreview)['■応募数報告その他先_5']">
                    <td class="bg-color1">
                        <b-form-checkbox
                            v-if="!isPreview && !isRolePartner"
                            class="mb-1"
                            switch
                            v-model="SWITCH_FIELD_TAB_5(dataObject)['■応募数報告その他先_5']"
                            @change="toggleCommonSwitch($event, { free_block_report_number: dataObject.free_block_report_number })"
                        />
                        <b-form-input
                            v-model="dataObject.free_block_report_number.title"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_5(dataObject)['■応募数報告その他先_5']"
                            :class="`${isDisabled || !SWITCH_FIELD_TAB_5(dataObject)['■応募数報告その他先_5'] ? 'disabled_cursor' : ''}`"
                        ></b-form-input>
                    </td>
                    <td>
                        <div
                            v-if="isNotCheckBoxPartner || isDisabled"
                            class="box--text__disabled"
                            v-html="dataObject.free_block_report_number.data"
                        ></div>
                        <Editor
                            v-else
                            :id="`editor-■応募数報告その他先_5-${idTab}`"
                            :model.sync="dataObject.free_block_report_number.data"
                            :configInit="{
                                disabled: forceEnableEditors ? false : isDisabled || !SWITCH_FIELD_TAB_5(dataObject)['■応募数報告その他先_5'],
                                is_autoresize_on: true
                            }"
                        />
                    </td>
                </tr>

                <tr>
                    <th colspan="4">■その他(特記)</th>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_5(dataObject, isPreview)['無効内容の詳細']">
                    <td class="bg-color1">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                switch
                                v-model="SWITCH_FIELD_TAB_5(dataObject)['無効内容の詳細']"
                                @change="
                                    toggleCommonSwitch($event, {
                                        invalid_content: dataObject.invalid_content
                                    })
                                "
                            />
                            無効内容の詳細
                        </div>
                    </td>
                    <td>
                        <TextareaComponent
                            id="tab5-textarea-9"
                            :model.sync="dataObject.invalid_content.data"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_5(dataObject)['無効内容の詳細']"
                            :isPreview="isPreview"
                            :config="inputConfig.invalid_content"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.invalid_content_first)"
                            v-model="dataObject.invalid_content.first_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('invalid_content', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.invalid_content_secondary)"
                            v-model="dataObject.invalid_content.secondary_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('invalid_content', 'secondary')"
                        />
                    </td>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_5(dataObject, isPreview)['その他連絡事項']">
                    <td class="bg-color1">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                switch
                                v-model="SWITCH_FIELD_TAB_5(dataObject)['その他連絡事項']"
                                @change="
                                    toggleCommonSwitch($event, {
                                        other_information: dataObject.other_information
                                    })
                                "
                            />
                            その他連絡事項
                        </div>
                    </td>
                    <td>
                        <TextareaComponent
                            id="tab5-textarea-10"
                            :model.sync="dataObject.other_information.data"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_5(dataObject)['その他連絡事項']"
                            :isPreview="isPreview"
                            :config="inputConfig.other_information"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.other_information_first)"
                            v-model="dataObject.other_information.first_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('other_information', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.other_information_secondary)"
                            v-model="dataObject.other_information.secondary_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('other_information', 'secondary')"
                        />
                    </td>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_5(dataObject, isPreview)['ディレクション確認内容']">
                    <td class="bg-color1">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                switch
                                v-model="SWITCH_FIELD_TAB_5(dataObject)['ディレクション確認内容']"
                                @change="
                                    toggleCommonSwitch($event, {
                                        confirm_detail_direction: dataObject.confirm_detail_direction
                                    })
                                "
                            />
                            ディレクション確認内容
                        </div>
                    </td>
                    <td>
                        <TextareaComponent
                            id="tab5-textarea-11"
                            :model.sync="dataObject.confirm_detail_direction.data"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_5(dataObject)['ディレクション確認内容']"
                            :isPreview="isPreview"
                            :config="inputConfig.confirm_detail_direction"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.confirm_detail_direction_first)"
                            v-model="dataObject.confirm_detail_direction.first_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('confirm_detail_direction', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.confirm_detail_direction_secondary)"
                            v-model="dataObject.confirm_detail_direction.secondary_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('confirm_detail_direction', 'secondary')"
                        />
                    </td>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_5(dataObject, isPreview)['フリーブロックその他先']">
                    <td class="bg-color1">
                        <b-form-checkbox
                            v-if="!isPreview && !isRolePartner"
                            class="mb-1"
                            switch
                            v-model="SWITCH_FIELD_TAB_5(dataObject)['フリーブロックその他先']"
                            @change="toggleCommonSwitch($event, { free_block_other: dataObject.free_block_other })"
                        />
                        <b-form-input
                            v-model="dataObject.free_block_other.title"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_5(dataObject)['フリーブロックその他先']"
                            :class="`${isDisabled || !SWITCH_FIELD_TAB_5(dataObject)['フリーブロックその他先'] ? 'disabled_cursor' : ''}`"
                        ></b-form-input>
                    </td>
                    <td>
                        <div v-if="isNotCheckBoxPartner || isDisabled" class="box--text__disabled" v-html="dataObject.free_block_other.data"></div>
                        <Editor
                            v-else
                            :id="`editor-${idTab}`"
                            :model.sync="dataObject.free_block_other.data"
                            :configInit="{
                                disabled: forceEnableEditors ? false : isDisabled || !SWITCH_FIELD_TAB_5(dataObject)['フリーブロックその他先'],
                                is_autoresize_on: true
                            }"
                        />
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import CommonMultiselect from './CommonMultiselect.vue';
import Editor from '@/components/Editor/main.vue';
import editorDelayMixin from '@/mixins/editorDelayMixin';
import CommonCheckbox from './CommonCheckbox.vue';
import TextareaComponent from '@/components/Textarea/main.vue';

import { InputText } from '@/components/Input';
import { formatDateTimeJapanese, toggleCommonSwitch, isRolePartner, onHandleDataCheckValueForPartner } from '@/views/pages/require/handlers';
import { SWITCH_FIELD_TAB_5, configHelperOptions, CONFIG_INPUT_TAB_5 } from '@/views/pages/require/const-field-tab';

export default {
    name: 'Tab5Require',
    mixins: [editorDelayMixin],
    props: {
        isNotCheckBoxPartner: {
            type: Boolean,
            default: () => false
        },
        keyTab: {
            type: [String],
            default: ''
        },
        idTab: {
            type: [String, Number],
            default: ''
        },
        dataObject: {
            type: Object,
            required: false
        },
        currentUser: {
            type: Object,
            required: false
        },
        detailBeginForDocument: {
            type: Object,
            required: false
        },
        isDisabled: {
            type: Boolean,
            default: false
        },
        isPreview: {
            type: Boolean,
            default: false
        },
        processingFields: {
            type: Object,
            default: () => ({})
        }
    },
    components: {
        CommonMultiselect,
        Editor,
        CommonCheckbox,
        InputText,
        TextareaComponent
    },
    data() {
        return {
            option: configHelperOptions.optionTab5,
            isRolePartner: isRolePartner(),
            inputConfig: CONFIG_INPUT_TAB_5()
        };
    },
    methods: {
        formatDateTimeJapanese,
        toggleCommonSwitch,
        SWITCH_FIELD_TAB_5,

        handleCheckBoxValue(fieldName, type, index, subFieldName) {
            const payload = onHandleDataCheckValueForPartner(this.keyTab, this.dataObject, fieldName);
            const emitFieldName = subFieldName ? `${fieldName}_${subFieldName}` : fieldName;
            this.$emit('handleTabCheckBoxValue', { payload, fieldName: emitFieldName, type, index });
        }
    },
    watch: {},
    mounted() {}
};
</script>

<style lang="scss" scoped>
.box8 input[type='text'] {
    width: 200px;
}
</style>
